export const ESTADO_CREADA = 1
export const ESTADO_PUBLICADA = 2
export const ESTADO_PAUSADA = 3
export const ESTADO_ELIMINADA = 4
export const ESTADO_VENCIDA = 5

export const SIN_PREGUNTAS_TEXTO = 'Esta publicación aún no tiene preguntas.'

export const TIPO_PRODUCTO_PRODUCTOS = 'Productos'
export const TIPO_PRODUCTO_SERVICIOS = 'Servicios'
export const TIPO_PRODUCTO_VEHICULOS = 'Vehículos'
export const TIPO_PRODUCTO_SCRAP = 'Scrap'

export const ID_CATEGORIA_SERVICIOS = 1540
export const ID_CATEGORIA_VEHICULOS = 1743

export const CATEGORIA_FIJA_POR_TIPO = {
  [TIPO_PRODUCTO_SERVICIOS]: ID_CATEGORIA_SERVICIOS,
  [TIPO_PRODUCTO_VEHICULOS]: ID_CATEGORIA_VEHICULOS
}

export const CATEGORIAS_EXCLUIDAS_POR_TIPO = {
  [TIPO_PRODUCTO_PRODUCTOS]: [ID_CATEGORIA_SERVICIOS, ID_CATEGORIA_VEHICULOS]
}

export const TIPOS_SIN_ESTADO_PRODUCTO = [TIPO_PRODUCTO_SERVICIOS]

export const requiereEstadoProducto = (tipoProducto) =>
  !TIPOS_SIN_ESTADO_PRODUCTO.includes(tipoProducto)
